import { ChangeDetectionStrategy, Component } from '@angular/core';
import { InfiniteScrollDirective } from '@df/module-infinite-scroll/infinite-scroll.directive';
import { ICmsComponent } from '@icms/core/content';
import { ModelComponent } from '../../../catalog/ui/model/model.component';
import { CmsComponentListingAbstract } from './cms-component-listing.abstract';
import { CMS_COMPONENT_LISTING_CONFIG } from './cms-component-listing.config';

@Component({
    selector: 'cms-component-listing',
    templateUrl: './cms-component-listing.component.html',
    standalone: true,
    imports: [InfiniteScrollDirective, ModelComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
@ICmsComponent<CmsComponentListingComponent>(CMS_COMPONENT_LISTING_CONFIG)
export class CmsComponentListingComponent extends CmsComponentListingAbstract {}
